import {Component, EventEmitter, Injector, OnInit, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {ModalBaseComponent} from '../modal-base-component';
import {POOLINFO} from "../../../../gen/swagger-api";

@Component({
  selector: 'app-cards-modal-modal',
  templateUrl: './import-cards-modal.component.html',
  styleUrls: ['./import-cards-modal.component.css']
})
export class ImportCardsModalComponent extends ModalBaseComponent implements OnInit {

  poolId: number;
  idArray: Array<string> = [];
  pools: Array<POOLINFO> = [];

  checked: any;
  fileList: FileList;
  public linear = true;
  public errorInput = {
    showUploadFileError: false,
    showOtaProfileError: false,
    showKeyVersionError: false,
    showScp03KeyVersionError: false,
    showPoolNameError: false,
  };

  public inputData = {
    cardGroup: '',
    otaProfile: '',
    keyVersion: '',
    scp03KeyVersion: '',
    country: '',
    mnoName: '',
    poolName: '',
  };

  @Output() action = new EventEmitter();

  constructor(private inject: Injector, private _bsModalRef: BsModalRef) {
    super(inject);
  }

  ngOnInit() {
  }

  public import() {
    const validation = this.validation();
    if (!validation) {
      return;
    }
    const file: File = this.fileList[0];
    const formData: FormData = new FormData();
    formData.append('importfile', file, file.name);
    formData.append('cardGroup', this.inputData.cardGroup);
    formData.append('otaProfile', this.inputData.otaProfile);
    formData.append('keyVersion', this.inputData.keyVersion.toString());
    formData.append('scp03KeyVersion', this.inputData.scp03KeyVersion.toString());
    if (this.linear) {
      formData.append('country', this.inputData.country);
      formData.append('mnoName', this.inputData.mnoName);
    } else {
      formData.append('poolName', this.inputData.poolName);
    }

    this.action.emit(formData);
    this.closeModal();
  }

  private validation(): boolean {
    if (this.fileList === undefined) {
      this.errorInput.showUploadFileError = true;
      return false;
    } else {
      this.errorInput.showUploadFileError = false;

    }

    if (this.inputData.otaProfile === undefined || this.inputData.otaProfile === '') {
      this.errorInput.showOtaProfileError = true;
      return false;
    } else {
      this.errorInput.showOtaProfileError = false;
    }

    if (this.inputData.keyVersion === undefined || this.inputData.keyVersion === '' || isNaN(parseInt(this.inputData.keyVersion, 10)) || +this.inputData.keyVersion < 0) {
      this.errorInput.showKeyVersionError = true;
      return false;
    } else {
      this.errorInput.showKeyVersionError = false;
    }

    if (this.inputData.scp03KeyVersion === undefined || this.inputData.scp03KeyVersion === '' || isNaN(parseInt(this.inputData.scp03KeyVersion, 10)) || +this.inputData.scp03KeyVersion < 0) {
      this.errorInput.showScp03KeyVersionError = true;
      return false;
    } else {
      this.errorInput.showScp03KeyVersionError = false;
    }

    if (!this.linear) {
      if (this.inputData.poolName === undefined) {
        this.errorInput.showPoolNameError = true;
        return false;
      } else {
        this.errorInput.showPoolNameError = false;
      }
    }

    return true;
  }

  public fileUpload(event) {
    this.fileList = event.target.files;
    if (this.fileList.length > 0) {
      this.errorInput.showUploadFileError = false;
    }
  }

  public setSelection(value) {
    this.linear = value;
  }

  close(value) {
    this.action.emit(value);
    this._bsModalRef.hide();
  }

  closeModal() {
    this._bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/import-cards-modal/import-cards-modal.component.ts